export default "__VITE_ASSET__f5b8bd66__"